import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

import {ReactComponent as SendIcon} from '../../images/send.svg'
import Button from '../Button'

export interface ISendEmail extends InputHTMLAttributes<HTMLInputElement> {
  onSend: () => void
  error?: string
}

const SWrapper = styled.div`
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 2px;
  box-shadow: 0 5px 12px rgba(21, 17, 15, .1);
  padding: 15px;
`

const SLabel = styled.div`
  margin-bottom: 25px;
`

const SCombineInput = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
`

const SButton = styled(Button)`
  display: flex;
  align-items: center;

  & > svg {
    margin-left: 5px;
  }
`

const SInput = styled.input`
  width: 100%;
  margin-right: -30px;
  height: 100%;
  font-weight: 500;
  color: #283345;
  background-color: #f2f2f2;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  padding: 0 55px 0 25px;

  &:focus {
    outline: none;
  }
  &::placeholder {
    font-weight: 500;
    color: #283345;
  }
`

const SError = styled.div`
  margin-top: 12px;
  color: red;
`

const SendEmail: React.FC<ISendEmail> = (props) => {
  const { className, onSend, error, ...rest } = props
  return (
    <SWrapper className={className}>
      <SLabel>Отправить расчет по почте</SLabel>
      <SCombineInput>
        <SInput placeholder="E-mail" {...rest} />
        <SButton onClick={onSend}>Отправить <SendIcon /></SButton>
      </SCombineInput>
      {error && (
        <SError>{error}</SError>
      )}
    </SWrapper>
  )
}

export default SendEmail